import { render, staticRenderFns } from "./release_parent_edit.vue?vue&type=template&id=74486d5a&scoped=true"
import script from "./release_parent_edit.vue?vue&type=script&lang=js"
export * from "./release_parent_edit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74486d5a",
  null
  
)

export default component.exports